import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import classNames from 'classnames';
import React,{Component} from 'react';
import DataMaintenanceForm from '../DataMaintenanceForm/DataMaintenanceForm';

import './CreateDataMaintenance.css';

interface Props{
    onCreate?: Function
}
interface State{
    creating: boolean

    // Creation 
    data_maintenance: any
}

const default_values:any = {
    'DCR':{
    },
    'service_request':{
    }
}

    // "product_type" jsonb,
    // "target_products" jsonb,
    // "nb_products" int,
    // "filters" jsonb,
    // "period" jsonb,
    // "aoi" jsonb,
    // "additional_requirements" jsonb,



export default class CreateDataMaintenance extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            creating: false,
            // creating: false,
            data_maintenance: {
                type: 'service_request',
                data:{
                    ...default_values['service_request']  
                }
            }
        }
    }
    
    render(){
        return (
            <div className="create-request">
                {/* <Optional>*Required</Optional> */}
                {/* <br/>
                <br/> */}

                <DataMaintenanceForm
                    data_maintenance={this.state.data_maintenance}
                    onChange={(updates:any, data?:boolean)=>{
                        this.setState({
                            data_maintenance: data ?
                                {
                                    ...this.state.data_maintenance,
                                    data:{
                                        ...this.state.data_maintenance.data,
                                        ...updates
                                    }
                                }
                            :
                                {
                                    ...this.state.data_maintenance,
                                    ...updates
                                }
                        });
                    }}
                />

                <br/>
                <br/>
                <div className="centered">
                    <div 
                        className={classNames({
                            "custom-button blue inline medium": true,
                            "disabled": this.state.creating
                        })}
                        onClick={this.create}
                    >
                        {
                            this.state.creating ? 
                            <Spinner height={15} white/>:
                            <><i className="fas fa-plus"/> ADD DATA MAINTENANCE</>
                        }

                    </div>
                </div>
            </div>
        );
    }


    create = async() =>{
        let { data_maintenance } = this.state;

        var body = new FormData();
        
        for(let attr of Object.keys(data_maintenance)){
            if(attr === 'data'){
                if(data_maintenance.data.description){
                    body.append('file', data_maintenance.data.description);
                }
                let data = { ...data_maintenance.data };
                delete data.description;
                body.append('data', JSON.stringify(data));
            }
            else
                body.append(attr, data_maintenance[attr]);
        }

        this.setState({ creating: true })
        try{
            let res = await request(`${API_URL}/api/v1/data_maintenances`,{
                method:'post',
                data: body
            })

            this.props.onCreate?.();
            this.setState({
                data_maintenance: {
                    type: data_maintenance.type,
                    data_id: '',
                    data: {
                        ...default_values[data_maintenance.type]
                    }
                }
            });

            create_toast({ type: 'success', message: `Successfully created data maintenance ${res.data.value.data_id}` })

            // console.log("this.state", this.state);
        }
        catch(e:any){
            axiosErrorHandler( e, { 
                functionName: 'create'
            })
            toast_request_error(e);
        }
        finally{
            this.setState({ creating: false })
        }
    }
};